import React, { useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';

const Header = () => {
  const { user, token, logout } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
  };

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/80 backdrop-blur">
      <div className="container mx-auto flex items-center justify-between px-4 py-4">
        <div className="flex items-center gap-3">
          <Link to={token ? '/' : '/'} className="text-xl font-semibold text-slate-900 tracking-tight">
            eCard<span className="text-blue-600">Hub</span>
          </Link>
          {token && user?.role !== 'superadmin' && (
            <span className="hidden rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-600 sm:inline-flex">
              Benvenuto, {user?.email?.split('@')[0] || 'utente'}
            </span>
          )}
        </div>

        <nav className="flex items-center gap-3">
          {token ? (
            <>
              {user?.role === 'superadmin' ? (
                <Link
                  to="/admin"
                  className={`rounded-full px-4 py-2 text-sm font-medium transition ${
                    isActive('/admin')
                      ? 'bg-slate-900 text-white shadow'
                      : 'text-slate-600 hover:bg-slate-100'
                  }`}
                >
                  Console Super Admin
                </Link>
              ) : (
                <>
                  <button
                    type="button"
                    onClick={() => navigate('/create-card')}
                    className="rounded-full bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-blue-500"
                  >
                    Nuovo biglietto
                  </button>
                  <button
                    type="button"
                    onClick={() => navigate('/bulk-create')}
                    className="hidden rounded-full border border-slate-200 px-4 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100 lg:inline-flex"
                  >
                    Importa CSV
                  </button>
                </>
              )}
              <button
                onClick={handleLogout}
                className="rounded-full border border-transparent bg-slate-900 px-4 py-2 text-sm font-medium text-white transition hover:bg-slate-800"
              >
                Esci
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="rounded-full px-4 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100"
              >
                Login
              </Link>
              <Link
                to="/register"
                className="rounded-full bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-blue-500"
              >
                Registrati
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
